module.exports = __webpack_public_path__ + "static/media/test_sound.cd47928f.svg";